import React from 'react';
import { FadeIn } from './FadeIn';

export const About = ({ headshot = "/lee-headshot-1.jpg", id = "about" }) => {
  return (
    <section id={id} className="relative py-32 md:py-48 bg-c-cream text-c-dark overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <FadeIn direction="right">
              <div className="aspect-[3/4] w-full max-w-sm mx-auto lg:mx-0 relative overflow-hidden rounded-xl shadow-glow-soft">
                <img
                  src={headshot}
                  alt="Lee Hurlbert, Founder of CHRSMA"
                  className="object-cover object-top w-full h-full grayscale hover:grayscale-0 hover:scale-105 transition-all duration-1000"
                />
              </div>
            </FadeIn>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
            <FadeIn delay={0.1} direction="left">
              <h2 className="text-xs font-medium tracking-super-wide uppercase text-c-dark/40 mb-8">About Lee</h2>
              <h3 className="text-4xl md:text-5xl font-light text-c-dark mb-10">
                Operator-led <span className="font-serif-italic text-c-mauve/80">strategy.</span>
              </h3>
              <div className="flex flex-col gap-6 text-lg text-c-dark/70 font-light leading-relaxed">
                <p>
                  Before advising companies on how to position themselves, Lee spent years building and scaling them. This operator background forms the DNA of CHRSMA.
                </p>
                <p>
                  We understand that strategy isn't just a slide deck; it's the tip of the spear for your entire organization. It dictates who you hire, what you build, and how you sell.
                </p>
                <p>
                  Lee works directly with a select number of founders and executive teams each year, bringing a practitioner's lens to the art of branding and positioning.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  );
};
